import React from "react";

import {
  Checkbox,
  TableCell,
  TableHead,
  TableRow,
  makeStyles,
} from "@material-ui/core";

import { TableHeaderProps } from "../../types";

const useStyles = makeStyles(() => ({
  dayCell: {
    width: 200,
  },
}));

const TableHeader: React.FC<TableHeaderProps> = ({
  numSelected,
  rowCount,
  onSelectAllClick,
  disabled = false,
}) => {
  const classes = useStyles();
  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ "aria-label": "select all days of the week" }}
            disabled={disabled}
          />
        </TableCell>
        <TableCell
          className={classes.dayCell}
          data-test="working-hours-day-header"
        >
          Day of week
        </TableCell>
        <TableCell data-test="working-hours-set-header">
          Set working hours
        </TableCell>
      </TableRow>
    </TableHead>
  );
};

export default TableHeader;
